import { Box, Skeleton } from "@mui/material";
const ModalSkeleton = () => (
  <Box>
    {/* Title-ish line */}
    <Skeleton variant="text" width="40%" height={30} sx={{ mb: 2 }} />

    {/* Description lines */}
    <Skeleton variant="text" width="80%" />
    <Skeleton variant="text" width="70%" sx={{ mb: 3 }} />

    {/* Main body block (like the method selection / form area) */}
    <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 1 }} />
  </Box>
);

export default ModalSkeleton;
